import { cx } from '../lib/cx';
import styles from './Logo.module.css';

type Props = {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

/** The `</SeaxDev/>` wordmark, rendered from the transparent PNG in /public (source: brand/). */
export function Logo({ size = 'md', className }: Props) {
  return (
    <img
      src="/seaxdev-logo.png"
      alt="SeaxDev"
      width={1304}
      height={260}
      decoding="async"
      className={cx(styles.logo, styles[size], className)}
    />
  );
}
